interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/7e959f42-2dc6-41f5-b1a3-5ba42a363ea3.png" 
            alt="BUBA d.o.o. Logo" 
            className="h-10 w-10 object-contain"
          />
          <span className={`text-lg font-semibold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            BUBA d.o.o.
          </span>
        </div>
        
        <div className="flex items-center gap-8">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('products')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            Products
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}
